import { render } from "./SetPassword.vue?vue&type=template&id=3e1e1974&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=3e1e1974&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1e1974"]])

export default __exports__